import React from 'react';
import { Dialog, DialogContent, DialogActions, Typography, Stack, Button, Box } from '@mui/material';
import Icon from '@/units/Icon';
import PublicAPI from '@/api/TreedisPublicDAO';
import { toast } from 'react-toastify';
import socket from '@/components/util/socket';

interface DeleteNoteModalProps {
  isDeleteNoteModalOpen: boolean;
  setIsDeleteNoteModalOpen: (value: boolean) => void;
  setThreads: (value: any[]) => void;
  selectedThread: any;
  setSelectedThread?: (value: any | null) => void;
  tourSlug: string;
  threads: any[];
  userId: number;
  removeThreadFromSpace: (note: any) => void;
}

export const DeleteNoteModal: React.FC<DeleteNoteModalProps> = ({
  threads,
  tourSlug,
  selectedThread,
  userId,
  setThreads,
  isDeleteNoteModalOpen,
  setIsDeleteNoteModalOpen,
  removeThreadFromSpace,
  setSelectedThread,
}) => {
  const handleDelete = async () => {
    setIsDeleteNoteModalOpen(false);
    if (!selectedThread) {
      toast.error('Could not delete note');
    }
    if (selectedThread.userId !== userId) {
      toast.error('You can not delete this note');
      return;
    }

    const result = await PublicAPI.deleteThread({
      data: { threadId: selectedThread.id },
    });

    if (result.message === 'Success') {
      const updatedNotes = threads.filter((t) => t.id !== selectedThread.id);

      setThreads(updatedNotes);
      await removeThreadFromSpace(selectedThread);
      socket.emit('thread_delete', { ...selectedThread, room: tourSlug });
    }
    if (setSelectedThread) {
      setSelectedThread(null);
    }
  };

  return (
    <Dialog
      open={isDeleteNoteModalOpen}
      onClose={() => setIsDeleteNoteModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-paper': { background: 'transparent', borderRadius: '12px' },
      }}
    >
      <Stack sx={{ maxWidth: '400px', background: 'white', borderRadius: '12px' }}>
      <DialogContent>
            <Box display="flex" alignItems="start" justifyContent="flex-start" paddingBottom={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '48px', height: '48px', borderRadius: '50%', background: '#FEF3F2' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '35px', height: '35px', borderRadius: '50%', background: '#FEE4E2' }}>
                  <Icon.Delete style={{ color: 'transparent', fontSize: 20 }} />
                </Box>
              </Box>
            </Box>
            <Typography variant="h6" align="left">
              Delete this note?
            </Typography>
            <Typography align="left" sx={{ color: '#667085', fontSize: '14px', fontWeight: '400' }}>
              Are you sure you want to delete this note? This action cannot be undone.
            </Typography>
          </DialogContent>
        <DialogActions>
          <Stack direction="row" spacing={2} justifyContent="space-between" width="100%" padding={2}>
            <Button
              variant="outlined"
              onClick={() => setIsDeleteNoteModalOpen(false)}
              style={{
                color: '#344054',
                flex: 1,
                marginRight: 12,
                border: '1px solid #D0D5DD',
                borderRadius: 8,
                height: 48,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleDelete}
              color="primary"
              style={{
                flex: 1,
                marginLeft: 12,
                borderRadius: 8,
                height: 48,
                background: '#D92D20',
              }}
            >
              Delete
            </Button>
          </Stack>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};
